import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import AdminEmailManagement from "../components/AdminEmailManagement";
import "./AdminDashboard.css";

const AdminDashboard = () => {
  const [adminUser, setAdminUser] = useState(null);
  const navigate = useNavigate();

  useEffect(() => {
    // Check if admin is logged in
    const storedAdmin = localStorage.getItem("admin_user");
    if (storedAdmin) {
      setAdminUser(JSON.parse(storedAdmin));
    } else {
      // Redirect to home if not logged in as admin
      navigate("/");
    }
  }, [navigate]);

  const handleLogout = () => {
    localStorage.removeItem("admin_user");
    navigate("/");
  };

  if (!adminUser) {
    return <div className="loading-admin">Laden...</div>;
  }

  return (
    <div className="admin-dashboard">
      <header className="admin-header">
        <div className="header-content">
          <div className="header-left">
            <h1>Beheerder Dashboard</h1>
          </div>
          <div className="header-right">
            <div className="admin-user-info">
              <div className="admin-avatar">
                {adminUser.email?.charAt(0).toUpperCase() || "A"}
              </div>
              <div className="admin-details">
                <div className="admin-role">Beheerder</div>
                <div className="admin-email">{adminUser.email}</div>
              </div>
              <button onClick={handleLogout} className="logout-btn" title="Uitloggen">
                Uitloggen
              </button>
            </div>
          </div>
        </div>
      </header>

      <main className="admin-main">
        <AdminEmailManagement />
      </main>

      <footer className="admin-footer">
        <p>© 2026 Sgoolfotografie | Beheerderspaneel</p>
      </footer>
    </div>
  );
};

export default AdminDashboard;

